import { render, staticRenderFns } from "./YpoEventTypeAhead.vue?vue&type=template&id=161fd0cc&scoped=true&"
import script from "./YpoEventTypeAhead.vue?vue&type=script&lang=js&"
export * from "./YpoEventTypeAhead.vue?vue&type=script&lang=js&"
import style0 from "./YpoEventTypeAhead.vue?vue&type=style&index=0&id=161fd0cc&lang=scss&scoped=true&"
import style1 from "./YpoEventTypeAhead.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161fd0cc",
  null
  
)

export default component.exports